import { useState } from 'react';
import { Modal } from 'antd';

import { ProgressiveBlurredImg } from 'components/base';
import { CloseModalSVG } from 'components/iconsSVG/close';
import { useLocale } from 'hooks';
import { useI18n } from 'context/i18n';

import styles from './style.module.css';

export function MonthlyInstallMents() {
  const { t } = useI18n();
  const [modalVisible, setModalVisible] = useState(false);
  const { country: market } = useLocale();

  return (
    <>
      <button
        onClick={() => setModalVisible(true)}
        className="extraInfoButton my-2 overflow-hidden text-ellipsis border-none bg-transparent p-0 text-left text-xs font-bold underline"
      >
        {t('ficha.producto', `pay.in.3.6.or.8.monthly.installments${market !== 'TR' ? `.${market.toLowerCase()}` : ''}`)}
      </button>
      <Modal
        title={t('ficha.producto', 'installments.titulo')}
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        wrapClassName={styles.modalWrapper}
        destroyOnClose={true}
        closeIcon={<CloseModalSVG />}
      >
        <div className="flex max-w-[560px] flex-col xl:grid xl:max-w-[850px] xl:grid-cols-3">
          <div className="px-6 py-12 text-left xl:col-span-2">
            <div
              dangerouslySetInnerHTML={{
                __html: t('ficha.producto', `installments.description${market !== 'TR' ? `.${market.toLowerCase()}` : ''}`).replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br />',
                ),
              }}
            />
          </div>
          <div className="xl:px-18 overflow-hidden p-8 max-xl:w-[190px] xl:grid xl:py-12">
            <ProgressiveBlurredImg highQualitySrc={'/assets-new/zapato_intallment.png'} alt={'image of installment'} width={151} height={409} />
          </div>
        </div>
      </Modal>
    </>
  );
}
